import React from "react";
import AddTheme from "./AddThemes";
import UpdateThemeImage from "./updateThemeImage";
import Header from "./header";
import GetItemInfo from "./getItemInfo";
import ItemDetail from "./getItemById";
import RemoveSizes from "./removeSize";
import ThemeDisplay from "./displayTheme";
import HeaderVideoUploader from "./HeaderVideoUploader";

function ThemeAndInfo() {
    return (
        <div>
         <div>
            <ThemeDisplay/>
                <AddTheme />
                <UpdateThemeImage/>
              <Header />
              <HeaderVideoUploader/>
              <GetItemInfo/>
              <ItemDetail/>
              <RemoveSizes/>
              </div>
        </div>
    )
}

export default ThemeAndInfo